module.exports = __webpack_public_path__ + "img/drivers-dont.c932c2c6.png";